export enum EntityEnum {
  STEMDOERS = 'STEMDOERS',
}
